import * as React from 'react';
import * as _ from 'lodash';
import { Col, FormControl, Button, Form, Row, Panel, InputGroup } from 'react-bootstrap';
import { IWaitlistAllocationConfig } from '@nkr/models/index'; //this is for loading of the initial data to page
import { IWaitlistAllocationData } from './waitlist-allocation-data'; //this is to update the state of initial data when posting
import { FormWrapper } from './styles';

interface IState extends IWaitlistAllocationData { };

interface IProps {
    data: IWaitlistAllocationConfig,
    onSave: (centerId: number, data: IState) => void
}

class WaitlistAllocation extends React.Component<IProps, IState>{
    readonly state: IState = {
        cpra98Points: this.props.data != null ? this.props.data.cpra98Points : -1,
        cpra99Points: this.props.data != null ? this.props.data.cpra99Points : -1,
        daysWaitPoints: this.props.data != null ? this.props.data.daysWaitPoints : -1,
        zeroEpletMmPoints: this.props.data != null ? this.props.data.zeroEpletMmPoints : -1,
        lowEpletMmPoints: this.props.data != null ? this.props.data.lowEpletMmPoints : -1,
        pediatricMaxAge: this.props.data != null ? this.props.data.pediatricMaxAge : -1,
        pediatricWaitDays: this.props.data != null ? this.props.data.pediatricWaitDays : -1,
        pediatricWaitPoints: this.props.data != null ? this.props.data.pediatricWaitPoints : -1,
        pediatricZeroEpletMmPoints: this.props.data != null ? this.props.data.pediatricZeroEpletMmPoints : -1,
        pediatricLowEpletMmPoints: this.props.data != null ? this.props.data.pediatricLowEpletMmPoints : -1,
    }

    handleCancel = () => {
        window.location.href = '/center/' + this.props.data.centerId + '/profile';
    }

    handleSave = () => {
        this.props.onSave(this.props.data.centerId, this.state);
    }

    handleChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let item = e.currentTarget.name;
        let state = _.cloneDeep(this.state);
        state[item] = e.currentTarget.value;

        this.setState(state);
    }

    render = () => {
        const disableSubmitButton = false;

        return (
            <div className='container-fluid' style={{ paddingBottom: 10 }}>
                <FormWrapper>
                    <Form inline>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Panel>
                                    <Panel.Heading>Wait Points</Panel.Heading>
                                    <Panel.Body>
                                        <Row>
                                            <Col xs={12} lg={6}>
                                                <InputGroup>
                                                    <InputGroup.Addon>+</InputGroup.Addon>
                                                    <FormControl
                                                        style={{ width: 70 }}
                                                        name='daysWaitPoints'
                                                        value={this.state.daysWaitPoints}
                                                        onChange={this.handleChange}
                                                    />
                                                    <InputGroup.Addon>points/day since registration</InputGroup.Addon>
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                    </Panel.Body>
                                </Panel>
                            </Col>

                            <Col xs={12} lg={6}>
                                <Panel>
                                    <Panel.Heading>Match Points</Panel.Heading>
                                    <Panel.Body>
                                        <div style={{ marginBottom: 5 }}>
                                            <InputGroup>
                                                <InputGroup.Addon>+</InputGroup.Addon>
                                                <FormControl
                                                    name='zeroEpletMmPoints'
                                                    style={{ width: 70 }}
                                                    value={this.state.zeroEpletMmPoints}
                                                    onChange={this.handleChange}
                                                />
                                                <InputGroup.Addon style={{ width: 177, textAlign: 'left' }}>points for 0 Eplet MM</InputGroup.Addon>
                                            </InputGroup>
                                        </div>

                                        <div>
                                            <InputGroup>
                                                <InputGroup.Addon>+</InputGroup.Addon>
                                                <FormControl
                                                    name='lowEpletMmPoints'
                                                    style={{ width: 70 }}
                                                    value={this.state.lowEpletMmPoints}
                                                    onChange={this.handleChange}
                                                />
                                                <InputGroup.Addon style={{ width: 177 }}>points for Low Eplet MM</InputGroup.Addon>
                                            </InputGroup>
                                        </div>
                                    </Panel.Body>
                                </Panel>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={6}>
                                <Panel>
                                    <Panel.Heading>Pediatric Points</Panel.Heading>
                                    <Panel.Body>
                                        <Row>
                                            <Col xs={12}>
                                                <div style={{ marginBottom: 15 }}>
                                                    <InputGroup>
                                                        <InputGroup.Addon>Pediatric is anyone</InputGroup.Addon>
                                                        <FormControl
                                                            name='pediatricMaxAge'
                                                            style={{ width: 70 }}
                                                            value={this.state.pediatricMaxAge}
                                                            onChange={this.handleChange}
                                                        />
                                                        <InputGroup.Addon>or younger</InputGroup.Addon>
                                                    </InputGroup>
                                                </div>

                                                <div style={{ marginBottom: 5 }}>
                                                    <InputGroup>
                                                        <InputGroup.Addon>+</InputGroup.Addon>
                                                        <FormControl
                                                            name='pediatricZeroEpletMmPoints'
                                                            style={{ width: 70 }}
                                                            value={this.state.pediatricZeroEpletMmPoints}
                                                            onChange={this.handleChange}
                                                        />
                                                        <InputGroup.Addon style={{ width: 177 }}>points for 0 eplet MM</InputGroup.Addon>
                                                    </InputGroup>
                                                </div>

                                                <div style={{ marginBottom: 5 }}>
                                                    <InputGroup>
                                                        <InputGroup.Addon>+</InputGroup.Addon>
                                                        <FormControl
                                                            name='pediatricLowEpletMmPoints'
                                                            style={{ width: 70 }}
                                                            value={this.state.pediatricLowEpletMmPoints}
                                                            onChange={this.handleChange}
                                                        />
                                                        <InputGroup.Addon style={{ width: 177 }}>points for Low Eplet MM</InputGroup.Addon>
                                                    </InputGroup>
                                                </div>

                                                <div>
                                                    <InputGroup>
                                                        <InputGroup.Addon>+</InputGroup.Addon>
                                                        <FormControl
                                                            name='pediatricWaitPoints'
                                                            style={{ width: 70 }}
                                                            value={this.state.pediatricWaitPoints}
                                                            onChange={this.handleChange}
                                                        />
                                                        <InputGroup.Addon style={{ width: 177 }}>points if more than</InputGroup.Addon>
                                                        <FormControl
                                                            name='pediatricWaitDays'
                                                            style={{ width: 70 }}
                                                            value={this.state.pediatricWaitDays}
                                                            onChange={this.handleChange}
                                                        />
                                                        <InputGroup.Addon>days(s) in NKR</InputGroup.Addon>
                                                    </InputGroup>
                                                </div>
                                            </Col>
                                        </Row>

                                    </Panel.Body>
                                </Panel>
                            </Col>

                            <Col xs={12} lg={6}>
                                <Panel>
                                    <Panel.Heading>CPRA Points</Panel.Heading>
                                    <Panel.Body>
                                        <div style={{ marginBottom: 5 }}>
                                            <InputGroup>
                                                <InputGroup.Addon>+</InputGroup.Addon>
                                                <FormControl
                                                    name='cpra98Points'
                                                    style={{ width: 70 }}
                                                    value={this.state.cpra98Points}
                                                    onChange={this.handleChange}
                                                />
                                                <InputGroup.Addon style={{ width: 182 }}>points for {'> ='} 98 and {'<'} 99</InputGroup.Addon>
                                            </InputGroup>
                                        </div>

                                        <div>
                                            <InputGroup>
                                                <InputGroup.Addon>+</InputGroup.Addon>
                                                <FormControl
                                                    name='cpra99Points'
                                                    style={{ width: 70 }}
                                                    value={this.state.cpra99Points}
                                                    onChange={this.handleChange}
                                                />
                                                <InputGroup.Addon style={{ width: 182, textAlign: 'left' }}>points for {'> ='} to 99</InputGroup.Addon>
                                            </InputGroup>
                                        </div>
                                    </Panel.Body>
                                </Panel>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={12} className='text-center'>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Button bsStyle='primary' bsSize='lg' onClick={this.handleSave} disabled={disableSubmitButton}>UPDATE WAIT LIST ALLOCATIONS</Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </FormWrapper>
            </div>
        );
    }
}

export default WaitlistAllocation;